import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import { useJwt } from "react-jwt";
import { GetAllModuleWithoutPage, GetModuleMode, GetProfileById } from '../apiconfig/authService';

function ViewProfile() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [profileData, setProfileData] = useState({});
    const [modulesData, setModulesData] = useState([]);
    const [moduleModesData, setModuleModesData] = useState([]);
    const [accessibleModules, setAccessibleModules] = useState([]);
    const { profileid } = useParams();

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetProfileById(profileid, localStorage.getItem('accessToken'));
                    setProfileData(response.data);
                    setAccessibleModules(response.data.accessiblemodules);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
        (
            async () => {
                try {
                    const modulesResponse = await GetAllModuleWithoutPage(localStorage.getItem('accessToken'));
                    setModulesData(modulesResponse.data);
                    const moduleModesResponse = await GetModuleMode(localStorage.getItem('accessToken'));
                    setModuleModesData(moduleModesResponse.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);

    const moduleCheckboxValue = (moduleid) => {
        const output = (accessibleModules.findIndex(item => {
            return item.moduleid === moduleid;
        }) !== -1) ? true : false;
        return output;
    };

    const tableCheckboxValue = (moduleid, modeid) => {
        return (accessibleModules.findIndex(item => {
            return item.moduleid === moduleid && item.accessibleviews.findIndex(element => element === modeid) !== -1;
        }) !== -1) ? true : false;
    };

    const moduleModeCheckboxValue = (modeid) => {
        return (accessibleModules.findIndex(item => {
            return item.accessibleviews.findIndex(element => element === modeid) !== -1;
        }) !== -1) ? true : false;
    };


    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Profile Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/profile" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                        <NavLink to={`/editProfile/${profileid}`} className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="table-responsive">
                                <h4 className="text-primary h6 fw-bold">Profile Information</h4>
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Profile ID</th>
                                            <td>{profileData.profileid}</td>
                                        </tr>
                                        <tr>
                                            <th>Profile Name</th>
                                            <td>{profileData.profilename}</td>
                                        </tr>
                                        <tr>
                                            <th>Profile Description</th>
                                            <td>{profileData.profiledescription}</td>
                                        </tr>
                                        <tr>
                                            <th>Created Date</th>
                                            <td>{formatUTCDate(profileData.createddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified Date</th>
                                            <td>{formatUTCDate(profileData.modifieddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Created By</th>
                                            <td>{profileData.createdby}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified By</th>
                                            <td>{profileData.modifiedby}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <h4 className="text-primary h6 fw-bold mt-4">Profile Privileges</h4>
                        <div className="table-responsive">
                            <table className="table table-borderless table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">Modules</span>
                                                <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                        {moduleModesData.map(item => {
                                            return (
                                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                                                    <div className="tableHeadItems position-relative">
                                                        <span className="text-ellipsis"><input checked={moduleModeCheckboxValue(item.modulemodeid)} className="form-check-input" type="checkbox" />{item.mode}</span>
                                                        <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                                    </div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        modulesData.map((module, index) => (
                                            <tr key={index}>
                                                <td><input className="form-check-input" checked={moduleCheckboxValue(module.moduleid)} type="checkbox" />{module.modulename}</td>
                                                {
                                                    moduleModesData.map(moduleMode => {
                                                        return (<td><input className="form-check-input" checked={tableCheckboxValue(module.moduleid, moduleMode.modulemodeid)} type="checkbox" /></td>);
                                                    })
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ViewProfile;